<template>
<svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0001 23.5C5.64428 23.5 0.5 18.3495 0.5 12.0001C0.5 5.6439 5.64321 0.5 12.0001 0.5C18.3563 0.5 23.5 5.6432 23.5 12.0001C23.5 18.3555 18.3489 23.5 12.0001 23.5Z" fill="#FBFDFE" :stroke="color_circle"/>
    <path d="M16 16.5V15.5C16 14.9696 15.7893 14.4609 15.4142 14.0858C15.0391 13.7107 14.5304 13.5 14 13.5H10C9.46957 13.5 8.96086 13.7107 8.58579 14.0858C8.21071 14.4609 8 14.9696 8 15.5V16.5" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 11.5C13.1046 11.5 14 10.6046 14 9.5C14 8.39543 13.1046 7.5 12 7.5C10.8954 7.5 10 8.39543 10 9.5C10 10.6046 10.8954 11.5 12 11.5Z" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: '24'
        },
        color_circle: {
          default: '#DFE2EB'
        },
        color: {
            default: '#A1A8B8'
        }
    }
}
</script>
